import React, { useRef, useEffect, useState } from "react";

const NestQuestROILogo = () => {
  const logoRef = useRef(null);
  const [logoWidth, setLogoWidth] = useState(null);

  useEffect(() => {
    const updateLogoWidth = () => {
      if (logoRef.current) {
        setLogoWidth(logoRef.current.offsetWidth);
      }
    };
    updateLogoWidth();
    window.addEventListener("resize", updateLogoWidth);
    return () => window.removeEventListener("resize", updateLogoWidth);
  }, []);

  return (
    <div className="flex flex-col items-center text-center font-extrabold w-full px-4 sm:px-6">
      {/* Logo */}
      <div
        ref={logoRef}
        className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl tracking-wide max-w-full whitespace-nowrap"
      >
        <span className="text-blue-700">Nest</span>
        <span className="text-green-600">Quest</span>
        <span className="text-blue-700">ROI</span>
      </div>

      {/* Responsive Dash Divider */}
      <div
        className="border-t-4 border-dashed border-blue-700 my-3"
        style={{
          width: logoWidth ? `${logoWidth}px` : "100%",
          maxWidth: "90vw",
        }}
      ></div>

      {/* Slogan */}
      <div className="text-sm sm:text-base md:text-lg font-semibold leading-relaxed max-w-[90vw] sm:max-w-3xl md:max-w-4xl">
        <span className="text-yellow-600">Gold never leaves the throne.</span>{" "}
        <span className="text-green-600">Real estate doesn’t retire.</span>
        <br />
        <span className="text-blue-700">
          Together, they don’t just grow wealth — they multiply it.
        </span>
      </div>
    </div>
  );
};

export default NestQuestROILogo;
